export default class SimpleFilter extends HTMLFormElement {

    connectedCallback() {

        this.addEventListener("input", this.filterItems);

    }

    disconnectedCallback() {

        this.removeEventListener("input", this.filterItems);

    }

    filterItems = (e) => {
        const data = new FormData(this);
        let selector = "";

        for (const pair of data.entries()) {
            const key = pair[0];
            const val = pair[1];

            if (key && val)
                selector += `[data-filter-${key}~=\"${val}\"]`;

        }

        this.listItems.forEach(el => {
            if (!selector) {
                el.classList.remove("d-none");
            }
            else { 
                el.classList.toggle("d-none", !el.matches(selector));
            }
        });
    }

    get listItems() {
        const data = new FormData(this);
        const selectors = [];

        for (const key of data.keys()) {
            selectors.push(`[data-filter-${key}]`);
        }

        return this.targetElement.querySelectorAll(selectors.join(","));
    }

    get targetElement() {
        return document.querySelector(this.dataset.target);
    }
}

customElements.define('simple-filter', SimpleFilter, { extends: 'form' });